module.exports = __webpack_public_path__ + "img/sheffield-united.abd58231.png";